
import React, { useState } from 'react'

interface Props {
  thing: Things,


}
interface Things {
  id: number,
  whatBuy: string,
  endDate: string,
  startDate: string,
  isDone: number,
  price: number,
}



const ThingsListEnd: React.FC<Props> = ({ thing }) => {



  return (
    <div className='allThings'>
      {
        thing.isDone == 1 ?
          (
            <div>
              {
                thing.startDate.length > 0 ? (
                  <div className='thingsListEnd'>

                    <input type="checkbox"
                      checked={true}
                      readOnly
                    ></input>
                    <s> {thing.whatBuy}  {thing.price} zł  </s>
                    <div>
                      <s>Promocja {thing.startDate} - {thing.endDate}</s>
                    </div>

                  </div>
                ) : (
                  <div className='thingsListEnd2'>
                    <input type="checkbox"
                      checked={true}
                      readOnly
                    ></input>
                    <s> {thing.whatBuy}  {thing.price} zł  </s>

                  </div>
                )
              }
            </div>
          ) :
          (
            <div>
              {
                thing.startDate.length > 0 ? (
                  <div className='thingsListEnd'>

                    <input type="checkbox"
                      checked={false}
                      readOnly
                    ></input>
                    <span> {thing.whatBuy}  {thing.price} zł  </span>
                    <div>
                      <span>Promocja {thing.startDate} - {thing.endDate}</span>
                    </div>

                  </div>
                ) : (
                  <div className='thingsListEnd2'>
                    <input type="checkbox"
                      checked={false}
                      readOnly
                    ></input>
                    <span> {thing.whatBuy}  {thing.price} zł  </span>

                  </div>
                )
              }
            </div>
          )
      }





    </div>
  )
}

export default ThingsListEnd